import styled from "styled-components";

export const StyledCounter = styled.span`
  display: inline-flex;
`;

export const Value = styled.input`
  font-size: 20px;
  font-weight: bold;
  padding-left: 10px;
  padding-right: 10px;
  border: none;
  width: auto;
  display: inline-block;
  text-align: center;
`;
